import PracticeRatingScale from '../practice-tasks/practice-task-rating-scale';

import { TaskType } from '../common/task-utility';

export const getPracticeComponent = (type) => {
    switch (type) {
        case TaskType.RATING.type:
            return PracticeRatingScale;
        default:
            return null;
    }
}